import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { listWorkflows } from '../application/list-workflows'
import { workflows$ } from '../store'
import { workflows as workflowsPort, notify } from '../wiring'

const useWorkflows = () => {
	const workflows = useSelector(workflows$)

	const reload = useEffectEvent(async () => {
		const result = await listWorkflows(workflowsPort, notify)
		workflows$.set(result)
	})

	useEffect(() => {
		reload()
	}, [])

	return { workflows, reload }
}

export { useWorkflows }
